// 题库/题目相关接口
const question = {
    get_question: '/question',         // 获取题目
    get_draft: '/draft/get_draft',  // 获取草稿
    get_question_progress: '/get_question_progress', //获取某个题目的进度
    set_question_progress: '/set_question_progress', //设置某个题目的进度
    get_bank_list: '/question-bank',    // 获取题库列表
    get_bank: '/question-bank/',        // 获取题库
    get_question_batch: '/question_batch', // 批量获取题目
    get_question_list_by_bank_id: '/question_list', // 根据题库ID获取题目列表，需要翻页参数以及bank_id
    get_bank_progress: '/get_bank_progress', // 获取题库进度
    set_bank_progress: '/set_bank_progress', // 设置题库进度
    new_bank_progress: '/new_bank_progress', // 创建题库进度
    list_bank_progress: '/list_bank_progress', // 获取题库进度列表
    get_daily_exercise: '/daily_exercise',
    active_bank_progress: '/active_bank_progress', // 激活题库进度
}
export default question; 